export default __webpack_public_path__ + "static/media/AD.7b784da9.svg";